module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/howtouse#_idTextAnchor001"
    }
  }, [_vm._v("How to Use This Study Guide")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A Theological Vision for Slow Church")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Terroir")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taste and See")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Stability")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fidelity to People and Place")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entering into the Suffering of Others")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Wholeness")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reconciliation of All Things")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Work")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cooperating with God’s Reconciling Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Sabbath")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rhythm of Reconciliation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Abundance")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Economy of Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Gratitude")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Receiving the Good Gifts of God")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idTextAnchor019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Hospitality")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idTextAnchor019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Generously Sharing God’s Abundance")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#_idTextAnchor021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Dinner Table Conversation as a Way of Being Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', {
    staticClass: "i"
  }, [_vm._v("Slow Church Study Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/authors#_idTextAnchor023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idTextAnchor024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright#_idTextAnchor025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 60
// module chunks = 0